// extracted by mini-css-extract-plugin
module.exports = {"buscar":"ClienteBuscar_buscar__ruSti","combo":"ClienteBuscar_combo__1Op43"};